// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';
import useOpenGRView from '../../modules/gift-race/hooks/useOpenGRView';
import { selectIsGREnabledAndNotForbidden } from '../../modules/gift-race/selectors/specifics/selectGRRuntime';
import { selectShowOperationBanners } from '../../selectors/operations.selector';

import MenuDesktopGRButton from './MenuDesktopGRButton';
import selectGRButtonProps from './MenuDesktopGRButton.selector';

const MenuDesktopGRButtonContainer = () => {
  const isGREnabled = useSelector(selectIsGREnabledAndNotForbidden);
  const showOperationBanners = useSelector(selectShowOperationBanners);
  const selectedProps = useSelector(selectGRButtonProps);
  const openGRView = useOpenGRView();

  const otherProps = useMemo(
    () => ({
      openGRView,
    }),
    [openGRView],
  );

  const enhancedProps = useMergeProps({ selectedProps, otherProps });

  return isGREnabled && showOperationBanners ? <MenuDesktopGRButton {...enhancedProps} /> : null;
};

export default MenuDesktopGRButtonContainer;
